<template>
  <div class="vue-gpickr">
    <div class="vue-gpickr-inner-container">
      <div class="vue-gpickr-controls-container fs14">
        <div class="label">位置</div>
        <div class="site-lists">
          <span
            class="site-list"
            :class="siteX == site.siteX && siteY == site.siteY ? 'active' : ''"
            v-for="(site, index) in siteLists"
            :key="'site_' + index"
            :dataX="site.siteX"
            :dataY="site.siteY"
            @click="changeSite(site)"
          ></span>
        </div>
        <div class="inp-wrap">
          <single-input ref="elInput" :value.sync="siteX" inputSuffixs="%" />
          <span class="input-bottom-label">横轴</span>
        </div>
        <div class="inp-wrap">
          <single-input ref="elInput" :value.sync="siteY" inputSuffixs="%" />
          <span class="input-bottom-label">纵轴</span>
        </div>
      </div>
      <div class="vue-gpickr-stops-container" ref="stopsContainer">
        <div class="vue-gpickr-stops-preview-container">
          <div class="vue-gpickr-stops-preview" :style="stopsPreviewStyle" @click.stop.prevent="addStop($event)"></div>
        </div>
        <div
          class="vue-gpickr-stop"
          v-for="(stop, index) in stops"
          :key="index"
          :style="stopStyle(index)"
          :class="{ active: index == currentStopIdx }"
          @mousedown.stop="handleMouseDown(index, $event)"
          @touchstart.stop="handleTouchstart(index, $event)"
        ></div>
      </div>
    </div>
    <color-picker ref="colorRef" v-model="currentColor" :colorsParams="colorsParams" :preset-colors="null" @changeColorParams="changeColorParams"/>
  </div>
</template>

<script>
import Sketch from "./Sketch.vue"
import RadialGradient from "./RadialGradient.js"

const COLOR = 0
const POSITION = 1
const COLOR_PARAMS = 2
const REMOVE_TRESHOLD = 50

export default {
  components: {
    colorPicker: Sketch
  },
  props: {
    value: {
      type: RadialGradient,
      default: () => new RadialGradient()
    },
    themeKey: {
      type: String,
      default: ""
    }
  },
  data() {
    this.containerBoundingClientRectangle = {}
    return {
      this1: this,
      currentStopIdx: 0,
      siteLists: [
        {
          siteX: 0,
          siteY: 0
        },
        {
          siteX: 50,
          siteY: 0
        },
        {
          siteX: 100,
          siteY: 0
        },
        {
          siteX: 0,
          siteY: 50
        },
        {
          siteX: 50,
          siteY: 50
        },
        {
          siteX: 100,
          siteY: 50
        },
        {
          siteX: 0,
          siteY: 100
        },
        {
          siteX: 50,
          siteY: 100
        },
        {
          siteX: 100,
          siteY: 100
        }
      ]
    }
  },
  mounted() {
    this.hueElement = document.getElementsByClassName("vc-hue-container")[0]
    this.hueElement.addEventListener("mousedown", this.beginValueChanging)
    this.hueElement.addEventListener("mouseup", this.endValueChanging)
    this.alphaElement = document.getElementsByClassName("vc-alpha-container")[0]
    this.alphaElement.addEventListener("mousedown", this.beginValueChanging)
    this.alphaElement.addEventListener("mouseup", this.endValueChanging)
  },
  beforeDestroy() {
    this.unbindEventListeners()
    this.hueElement.removeEventListener("mousedown", this.beginValueChanging)
    this.hueElement.removeEventListener("mouseup", this.endValueChanging)
    this.alphaElement.removeEventListener("mousedown", this.beginValueChanging)
    this.alphaElement.removeEventListener("mouseup", this.endValueChanging)
  },
  computed: {
    siteX: {
      get() {
        return Number(this.value.siteX)
      },
      set(val) {
        let stops = this.stops
        this.emitInput(Number(val), this.siteY, this.stops, this.limit)
        this.$emit("update", { siteX: Number(val), siteY: this.siteY, stops })
      }
    },
    siteY: {
      get() {
        return Number(this.value.siteY)
      },
      set(val) {
        let stops = this.stops
        this.emitInput(this.siteX, Number(val), this.stops, this.limit)
        this.$emit("update", { siteX: this.siteX, siteY: Number(val), stops })
      }
    },
    stops: {
      get() {
        return this.value.stops.slice().map(stop => [...stop])
      },
      set(val) {
        let newVal = val.slice().sort((a, b) => a[POSITION] - b[POSITION])
        this.$emit("update", { siteX: this.siteX, siteY: this.siteY, stops: newVal })
      }
    },
    // previewStyle() {
    //   return { background: this.getGradientString(this.angle) }
    // },
    stopsPreviewStyle() {
      return { background: this.getGradientString(90) }
    },
    currentColor: {
      get() {
        return this.stops[this.currentStopIdx][COLOR]
      },
      set(val) {
        const { r, g, b, a } = val.rgba
        const newA = Number(`${a}`.includes(".") ? `${(a + "").slice(0, 4)}` : `${a}`)
        this.stops[this.currentStopIdx][COLOR] = `rgba(${r},${g},${b},${newA})`
        if(a !== newA) {
          this.$refs.colorRef.colorChange({
            r: r,
            g: g,
            b: b,
            a: newA,
            source: 'rgba'
          })
        }
        this.$set(this, "stops", this.stops)
        this.emitInput(this.siteX, this.siteY, this.stops, this.limit)
      }
    },
    colorsParams() {
      return this.stops[this.currentStopIdx][COLOR_PARAMS]
    },
    orderedStops() {
      return this.value.stops.slice().sort((a, b) => a[POSITION] - b[POSITION])
    },
    limit() {
      return this.value.limit
    }
  },
  methods: {
    emitInput(siteX, siteY, stops, limit) {
      this.$emit("input", new RadialGradient({ siteX, siteY, stops, limit }))
    },
    getGradientString(angle) {
      const stops = this.orderedStops.map(stop => `${stop[COLOR].toString()} ${stop[POSITION] * 100}%`).join(",")
      return `linear-gradient(${angle}deg, ${stops})`
    },
    setCurrentStopIdx(index) {
      this.currentStopIdx = index
    },
    stopStyle(index) {
      const stop = this.stops[index]
      return { left: `${stop[POSITION] * 100}%`, color: stop[COLOR].toString() }
    },
    addStop(event) {
      if (this.limit && this.stops.length >= this.limit) {
        return
      }
      const position = Math.round((event.offsetX * 100) / event.target.offsetWidth) / 100
      const index = this.stops.length
      let temObj = JSON.parse(JSON.stringify(this.stops))
      temObj.push([this.currentColor, position, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0
      }])
      this.stops.push([this.currentColor, position, {
        colorOpacity: 100,
        isThemeColor: false,
        themeColorId: 0
      }])
      this.$set(this, "stops", temObj)
      this.setCurrentStopIdx(index)
      this.emitInput(this.siteX, this.siteY, this.stops, this.limit)
    },
    removeCurrentStop() {
      let temObj = JSON.parse(JSON.stringify(this.stops))
      temObj.splice(this.currentStopIdx, 1)
      this.stops.splice(this.currentStopIdx, 1)
      this.$set(this, "stops", temObj)
      if (this.currentStopIdx > 0) {
        this.setCurrentStopIdx(this.currentStopIdx - 1)
      }
      this.unbindEventListeners()
      this.emitInput(this.siteX, this.siteY, this.stops, this.limit)
    },
    setContainerBoundingClientRectangle() {
      this.containerBoundingClientRectangle = this.$refs.stopsContainer.getBoundingClientRect()
    },
    handleChange(event) {
      // event.preventDefault();
      console.log(this.stops)
      event.stopPropagation()

      if (this.stops.length > 2) {
        // Gradient must have at least 2 stops
        const y = (event.touches ? event.touches[0].clientY : event.clientY) || 0
        const verticalDistance = Math.abs(y - this.containerBoundingClientRectangle.bottom)

        if (verticalDistance > REMOVE_TRESHOLD) {
          this.removeCurrentStop()
          return
        }
      }

      const x = (event.touches ? event.touches[0].clientX : event.clientX) || 0
      const left = x - this.containerBoundingClientRectangle.left

      const containerWidth = this.containerBoundingClientRectangle.width

      let position
      if (left < 0) {
        position = 0
      } else if (left > containerWidth) {
        position = 1
      } else {
        position = Math.round((left * 100) / containerWidth) / 100
      }

      const previousPosition = this.stops[this.currentStopIdx][POSITION]
      this.stops[this.currentStopIdx][POSITION] = position
      if (previousPosition != position) {
        this.emitInput(this.siteX, this.siteY, this.stops, this.limit)
      }
    },
    handleMouseDown(index) {
      console.log(this.stops)
      this.setCurrentStopIdx(index)
      this.setContainerBoundingClientRectangle()
      window.addEventListener("mousemove", this.handleChange)
      window.addEventListener("mouseup", this.handleMouseUp)
    },
    handleMouseUp() {
      this.unbindEventListeners()
    },
    unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange)
      window.removeEventListener("mouseup", this.handleMouseUp)
      window.removeEventListener("touchmove", this.handleChange, { passive: false })
      window.removeEventListener("touchend", this.handleTouchend)
      window.removeEventListener("touchcancel", this.handleTouchend)
    },
    handleTouchstart(index) {
      this.setCurrentStopIdx(index)
      this.setContainerBoundingClientRectangle()
      window.addEventListener("touchmove", this.handleChange, { passive: false })
      window.addEventListener("touchend", this.handleTouchend)
      window.addEventListener("touchcancel", this.handleTouchend)
    },
    handleTouchend() {
      this.unbindEventListeners()
    },
    changeSite(site) {
      this.siteX = site.siteX
      // 延时执行的原因是因为 get方法 emit  需要一定的时间
      setTimeout(() => {
        this.siteY = site.siteY
      }, 10)
    },
    beginValueChanging() {
      // 延时是为了不影响第一次记录
      setTimeout(function () {
        sessionStorage.setItem("historyValueChangeing", "1")
      })
    },
    endValueChanging() {
      setTimeout(function () {
        sessionStorage.removeItem("historyValueChangeing")
      })
    },
    changeColorParams(val) {
      let newVal = JSON.parse(JSON.stringify(this.stops))
      newVal[this.currentStopIdx][COLOR_PARAMS] = val
      this.$set(this, "stops", newVal)
      this.emitInput(this.angle, newVal, this.limit)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .vc-sketch {
    width: 100%;
    padding: 0;
    margin-top: 16px;
    background: none;
    box-shadow: none;
    .vc-sketch-presets {
      display: none;
    }
    .vc-sketch-controls {
      margin-top: 8px;
      .vc-sketch-sliders .vc-hue,
      .vc-sketch-sliders .vc-alpha-gradient {
        border-radius: 0px;
      }
    }
    .vc-sketch-saturation-wrap {
      overflow: visible;
      .vc-saturation-circle {
        width: 16px;
        height: 16px;
        border: 2px solid #ffffff;
        box-shadow: none;
        transform: translate(-8px, -8px);
      }
    }
    .vc-saturation-pointer {
      margin-top: -2px;
    }
    .vc-sketch-alpha-wrap {
      margin-top: 8px;
    }
    .vc-sketch-color-wrap {
      width: 30px;
      height: 30px;
      .vc-checkerboard {
        background-image: none !important;
      }
    }
    .vc-sketch-active-color {
      border-radius: 50%;
      border: 1px solid #dddddd;
    }
    .vc-sketch-field {
      margin-top: 8px;
      padding: 0;
      input {
        text-align: center;
        padding: 4px 0 3px;
        background: var(--bgColorPickerInputBgColor) !important;
        border-radius: 4px;
        color: var(--bgColorPickerInputColor) !important;
      }
      .vc-input__input {
        box-shadow: none;
      }
      .vc-input__label {
        color: var(--bgColorPickerInputLabelColor) !important;
        font-weight: 500;
        font-size: 12px;
      }
    }
  }
}
.vue-gpickr {
  position: relative;
  .vue-gpickr-inner-container {
    user-select: none;
    padding-right: 10px;
    .vue-gpickr-stops-container {
      position: relative;
      .vue-gpickr-stops-preview-container {
        height: 16px;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMElEQVQ4T2N89uzZfwY8QFJSEp80A+OoAcMiDP7//483HTx//hx/Ohg1gIFx6IcBALl+VXknOCvFAAAAAElFTkSuQmCC);
        background-size: 10px;
        position: relative;
        margin-top: 16px;
        border-radius: 2px;
        .vue-gpickr-stops-preview {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: -10px;
          border-radius: 2px;
          box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15), inset 0 0 4px rgba(0, 0, 0, 0.25);
        }
      }
      .vue-gpickr-stop {
        position: absolute;
        top: 0;
        transform: translate(0, 0);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
        &::before {
          content: "";
          width: 10px;
          height: 16px;
          border: 2px solid #fff;
          background: currentColor;
        }
        &.active {
          z-index: 3;
          &::before {
            content: "";
            width: 10px;
            height: 16px;
            border: 2px solid #fff;
            box-shadow: 0 0 0 2px #1770ff;
            background: currentColor;
          }
        }
      }
    }
    .vue-gpickr-controls-container {
      margin-top: 8px;
      display: flex;
      align-items: center;
      text-align: center;
      color: var(--text);
      .label {
        width: 40px;
        text-align: left;
      }
    }
  }
}
.site-list {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 1px;
  margin: 0 2px 3px 1px;
  background: var(--themeColorDisabled);
  cursor: pointer;
  &:nth-child(3n) {
    margin-right: 0;
  }
}
.site-list.active {
  background: var(--themeColor);
}
.site-lists {
  width: 59px;
  font-size: 0;
}
.inp-wrap {
  width: 57px;
  margin-left: 12px;
}
.inp-wrap ::v-deep .el-input__inner {
  padding-left: 8px;
}
.input-bottom-label {
  display: inline-block;
  margin-top: 4px;
  line-height: 17px;
  color: var(--subTextColor);
}
@media (max-width: 430px) {
  .vue-gpickr {
    flex-direction: column;
    .vue-gpickr-inner-container {
      padding-left: 10px;
      padding-top: 0;
    }
  }
}
</style>
